import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useDrawerNavigationState = () => {
  const { pathname } = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawerVisibility = useCallback((isOpen: boolean) => setIsDrawerOpen(isOpen), []);

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [pathname]);

  return {
    isDrawerOpen,
    toggleDrawerVisibility,
  };
};
